export default __webpack_public_path__ + "model-cardModelNlpd2a38b.png";